import type { AssetAssetType } from "./asset.type";

import { useState } from "react";

import { useGetAssetType } from "@/entities/asset-type";

export const useAssetEditAssetType = (existingAssetType?: AssetAssetType) => {
  const existingAssetTypeId = existingAssetType?.id;
  const existingTemplateId = existingAssetType?.entity_template_id;

  const [newAssetTypeId, setAssetTypeId] = useState(existingAssetTypeId);

  const { assetType, isLoading, isSuccess } = useGetAssetType(newAssetTypeId, {
    enabled: !!newAssetTypeId && newAssetTypeId !== existingAssetTypeId,
  });

  const newTemplateId = assetType?.entity_template_id;

  const showAssetTypeAlert =
    existingTemplateId && isSuccess && newTemplateId !== existingTemplateId;

  return {
    assetTypeId: newAssetTypeId,
    setAssetTypeId,
    isAssetTypeLoading: isLoading,
    showAssetTypeAlert,
  };
};
